// @flow
import { getSize } from "views/resources/theme";
import React, { type ChildrenArray } from "react";
import styled from "styled-components";

type Props = {|
	type: string,
	light?: boolean,
	children: ChildrenArray<*>,
|};

const Filter = ({ type = "disabled", light, children }: Props) => (
	<Wrapper type={type} light={light}>
		{children}
	</Wrapper>
);

const Wrapper = styled.div`
	box-sizing: border-box;
	height: 24px;
	font-size: 10px;
	font-weight: 600;
	line-height: 20px;
	text-align: center;
	padding: 2px 10px;
	border-radius: 20px;
	border: 1px solid #ffffff;
	&:hover {
		background-color: #d45147;
		border: 1px solid #d45147;
	}
	.ripple {
		display: inline-block;
		position: relative;
		top: -2;
		margin-left: 4px;
	}
`;

export default Filter;
